import { json, type DataFunctionArgs } from '@remix-run/node'
import { useEffect, useRef } from 'react'
import invariant from 'tiny-invariant'
import { Link, useLoaderData, Outlet, useMatches } from '@remix-run/react'
import { GeneralErrorBoundary } from '~/components/error-boundary.tsx'
import { Button } from '~/components/ui/button.tsx'
import { DeleteRecipeButton } from '~/routes/resources+/delete-recipe.tsx'
import { getUserId } from '~/utils/auth.server.ts'
import { getRecipe, getRecipeOwnerDetails } from '~/utils/recipe.server.ts'
import { matchRoute } from '~/utils/misc.ts'
import RecipeCard from '~/components/Recipes/RecipeCard.tsx'

export async function loader({ request, params }: DataFunctionArgs) {
	const { username, recipeSlug } = params
	invariant(username, 'Missing username')
	invariant(recipeSlug, 'Missing recipe in url')

	const recipe = await getRecipe(username, recipeSlug)

	console.log('recipe :>> ', recipe)
	if (!recipe) {
		throw new Response('Not found', { status: 404 })
	}

	const userId = await getUserId(request)
	const user = await getRecipeOwnerDetails(username)
	// console.log('USER :>> ', user)

	return json({ recipe, user, isOwner: userId === recipe.ownerId })
}

export default function RecipeRoute() {
	const recipeCardRef = useRef<HTMLDivElement>(null)
	const { recipe, isOwner, user } = useLoaderData<typeof loader>()
	const isEditPage = matchRoute(useMatches(), '/edit')
	const isEmbedded = Boolean(matchRoute(useMatches(), '/recipe-embed'))
	// console.log('isEditor :>> ', isEditPage)
	useEffect(() => {
		console.log('Inside useEffect')
		console.log('isEmbedded :>> ', isEmbedded)
		const cardHeight = recipeCardRef.current?.offsetHeight
		console.log('cardHeight :>> ', cardHeight)
		console.log('window :>> ', window)
		window.parent.postMessage(cardHeight, '*')
		// if (isEmbedded) {
		// 	window.addEventListener('load', event => {
		// 		const cardHeight = recipeCardRef.current?.offsetHeight
		// 		console.log('cardHeight :>> ', cardHeight)
		// 		console.log('page is fully loaded')
		// 	})

		// 	// if(window)
		// 	// window.parent.postMessage(cardHeight, '*')
		// }
	})
	console.log('isEmbedded :>> ', isEmbedded)
	return (
		<div className="flex h-full flex-col">
			<Outlet />
			{isOwner ? (
				<div className="flex justify-end gap-4">
					{isEditPage ? null : (
						<>
							<DeleteRecipeButton id={recipe.id} />
							<Button asChild variant="secondary">
								<Link to="edit">Edit</Link>
							</Button>
						</>
					)}
				</div>
			) : null}
			{!isEditPage && (
				<div ref={recipeCardRef}>
					<RecipeCard
						isEmbedded={isEmbedded}
						recipe={recipe}
						isOwner={isOwner}
						previewURL={null}
						user={user}
					/>
				</div>
			)}
		</div>
	)
}

export function ErrorBoundary() {
	return (
		<GeneralErrorBoundary
			statusHandlers={{
				404: () => <p>Recipe not found</p>,
			}}
		/>
	)
}
